import axios from 'axios'

const options = {
  ...axios.defaults,
}

const API = axios.create(options)

export default API
